import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
	selector: 'mat-card-wrapper',
	standalone: true,
	imports: [MatCardModule, NgIf],
	template: `
		<mat-card class="{{ props.class || 'linq-card' }}">
			<ng-container #fieldComponent></ng-container>
		</mat-card>
	`,
})
export class MatCardWrapperComponent extends FieldWrapper {}
